import { ValidationError } from "@p0security/shared/types/error";

export const salesforceDomainPattern = /^[\w.-]+\.my\.salesforce\.com$/g;

/** Throws unless `value` is a Salesforce My Domain host, so that P0 never
 * sends a Salesforce credential to another host (SSRF). */
export function validateSalesforceDomain(value: string) {
  if (!value.match(salesforceDomainPattern)) {
    throw new ValidationError(
      "fullDomain",
      { value },
      "Full domain must be a Salesforce login domain (ending with my.salesforce.com)"
    );
  }
}

/** The org's base URL, e.g. `https://my-org.my.salesforce.com` */
export const salesforceBaseUrl = (
  domain: string,
  fullDomain: string | undefined
): string =>
  // boolean coalesce to handle empty strings
  `https://${fullDomain || `${domain}.my.salesforce.com`}`;
